type MessageSet = Record<string, string>

const TRANSLATION_KEY_PREFIX = 'vfb.validation.'

export const VALIDATION_TRANSLATION_KEYS: Record<string, string> = {
    required: `${TRANSLATION_KEY_PREFIX}required`,
    requiredIf: `${TRANSLATION_KEY_PREFIX}requiredIf`,
    email: `${TRANSLATION_KEY_PREFIX}email`,
    number: `${TRANSLATION_KEY_PREFIX}number`,
    integer: `${TRANSLATION_KEY_PREFIX}integer`,
    minLength: `${TRANSLATION_KEY_PREFIX}minLength`,
    maxLength: `${TRANSLATION_KEY_PREFIX}maxLength`,
    min: `${TRANSLATION_KEY_PREFIX}min`,
    max: `${TRANSLATION_KEY_PREFIX}max`,
    pattern: `${TRANSLATION_KEY_PREFIX}pattern`,
    minCheck: `${TRANSLATION_KEY_PREFIX}minCheck`,
    maxCheck: `${TRANSLATION_KEY_PREFIX}maxCheck`,
    file: `${TRANSLATION_KEY_PREFIX}file`,
    maxFiles: `${TRANSLATION_KEY_PREFIX}maxFiles`,
    maxFileSize: `${TRANSLATION_KEY_PREFIX}maxFileSize`,
    fieldsetMinCount: `${TRANSLATION_KEY_PREFIX}fieldsetMinCount`,
}

export const FALLBACK_MESSAGES: MessageSet = {
    required: 'Please enter a value',
    requiredIf: 'Please enter a value',
    email: 'Please enter a valid email address',
    number: 'Please enter a number',
    integer: 'Please enter an integer',
    minLength: 'Please enter at least ${param} characters',
    maxLength: 'Please enter no more than ${param} characters',
    min: 'Please enter a value of at least ${param}',
    max: 'Please enter a value of at most ${param}',
    pattern: 'Please enter a valid value',
    minCheck: 'Please select at least ${param} options',
    maxCheck: 'Please select at most ${param} options',
    file: 'Allowed file types: ${param}',
    maxFiles: 'A maximum of ${param} files is allowed',
    maxFileSize: 'Each file may be at most ${param} KB',
    fieldsetMinCount: 'Please add at least ${param} group(s).',
}

export function resolveValidationMessages(
    serverMessages?: Record<string, string> | null,
): MessageSet {
    const messages: MessageSet = { ...FALLBACK_MESSAGES }

    if (!serverMessages) {
        return messages
    }

    for (const rule of Object.keys(VALIDATION_TRANSLATION_KEYS)) {
        const value = serverMessages[rule]
        if (typeof value === 'string' && value.trim() !== '' && !value.startsWith(TRANSLATION_KEY_PREFIX)) {
            messages[rule] = value
        }
    }

    return messages
}
